<template>
  <div id="manage-intent" v-if="intent">
    <div>
      <v-layout wrap style="border-bottom: 1px solid #eee" class="mb-3" v-if="!isWelcome">
        <v-flex
          xs12
          sm5
          md6
          form-control
          :class="{ 'has-error': errors.has('intentName') }"
          class="px-2 pt-2"
        >
          <input
            type="text"
            v-if="!isDefault"
            :readonly="isReadonly"
            class="form-control"
            :placeholder="$t('Conversation')"
            v-model="intent.intentname"
            name="intentName"
            :data-vv-as="$t('Conversation')"
            aria-describedby="Intent Name"
            v-validate="
              'required|excludednew:{default},{welcome}' + (excludedName ? ',' + excludedName : '')
            "
          />
          <div v-else>
            <template v-if="intent.intentname == '{default_comment_to_inbox}'">
              <p>{{ $t('More Comment to Inbox') }}</p>
            </template>
            <template v-else>
              <p>{{ $t('Default Conversation') }}</p>
            </template>
          </div>
          <span class="text-error" v-show="errors.has('intentName')">{{
            errors.first('intentName')
          }}</span>
        </v-flex>
        <v-flex xs12 sm7 md6 class="px-2 pt-2">
          <slot name="action"></slot>
          <div v-if="showReplyCommentSelectPost" class="text-xs-right">
            <template v-if="$store.getters.getPackage == 'premium'">
              <v-btn color="primary" small outline @click="showSelectPost = true">
                <template v-if="postidlist.includes.length == 0 && postidlist.excludes.length == 0">
                  {{ $t('Replying all post(s)') }}
                </template>
                <template v-else-if="postidlist.includes.length > 0">
                  {{ $t('Post(s) will be replied') }} ({{ postidlist.includes.length }})
                </template>
                <template v-else-if="postidlist.excludes.length > 0">
                  {{ $t("Post(s) won't be replied") }} ({{ postidlist.excludes.length }})
                </template>
                <v-icon small>edit</v-icon>
              </v-btn>

              <intent-select-post
                :includePost="intent.postidlist"
                :excludePost="intent.exceptpostidlist"
                :show="showSelectPost"
                :useexclude="true"
                @save="saveFilterPost"
                @close="showSelectPost = false"
              ></intent-select-post>
            </template>

            <v-btn color="grey" disabled v-else outline>
              <template v-if="postidlist.includes.length == 0 && postidlist.excludes.length == 0">
                {{ $t('Replying all post(s)') }}
              </template>
              <template v-else-if="postidlist.includes.length > 0">
                {{ $t('Post(s) will be replied') }} ({{ postidlist.includes.length }})
              </template>
              <template v-else-if="postidlist.excludes.length > 0">
                {{ $t("Post(s) won't be replied") }} ({{ postidlist.excludes.length }})
              </template>
              <v-icon class="ml-1">edit</v-icon>
              <v-premium-lock></v-premium-lock>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs12 class="px-2 pt-1 pb-2" align-end>
          <v-layout row wrap>
            <v-flex xs6 class="text-xs-left">
              <toggle-button
                :value="intent.intentstatus"
                :sync="true"
                :color="$vuetify.theme.success"
                @change="onChangeIntentStatus"
                :labels="{ checked: 'ON', unchecked: 'OFF' }"
              />
              <span class="mr-2">{{ $t('Turn On/Off Conversation') }}</span>
            </v-flex>
            <v-flex xs6>
              <v-layout wrap justify-end class="py-0 my-0">
                <div>
                  <v-checkbox
                    class="my-0 py-0"
                    hide-details
                    v-model="intent.ispriority"
                    color="success"
                    :label="$t('First Priority')"
                  ></v-checkbox>
                </div>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs12 sm6 class="pa-1 pl-2 pr-2">
          <template v-if="!isDefault">
            <intent-question v-model="intent.q_val"></intent-question>
          </template>
          <template v-else>
            <p class="small" style="margin-bottom: 0px">
              <template v-if="intent.intentname == '{default}'"></template>
              <template v-else-if="intent.intentname == '{default_comment_to_inbox}'"></template>
            </p>
          </template>
        </v-flex>
        <v-flex xs12 sm6 class="pa-1">
          <!-- <div class="hr show-on-small hide-on-med-and-up" style="margin: 15px -15px"></div> -->
          <template v-if="(isReplyComment && isCommentToInbox) || isLiveStream">
            <intent-comment
              :isLiveStream="isLiveStream"
              v-model="messages"
              :intentname="intent.intentname"
            ></intent-comment>
          </template>
          <template v-else-if="isWelcome">
            <slot name="welcome"></slot>
          </template>
          <template v-else>
            <v-layout>
              <v-flex
                v-if="showMultipleChannel"
                class="channel"
                shrink
                style="border-right: 1px solid #eee"
              >
                <div
                  :class="{ 'primary white--text': tab == 'facebook' }"
                  @click="tab = 'facebook'"
                  class="py-1 pl-2 pr-2"
                  style="
                    border: 1px solid #eee;
                    border-width: 1px 0px 1px 1px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    cursor: pointer;
                  "
                >
                  <span class="fab fa-facebook"></span>
                </div>
                <div
                  :class="{ 'primary white--text': tab == 'line' }"
                  @click="tab = 'line'"
                  class="py-1 pl-2 pr-2"
                  style="
                    border: 1px solid #eee;
                    border-width: 1px 0px 1px 1px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    cursor: pointer;
                  "
                >
                  <span class="fab fa-line"></span>
                </div>
              </v-flex>
              <v-flex style="overflow: auto" :key="timestamp">
                <template v-if="!showMultipleChannel">
                  <intent-group
                    v-model="messages"
                    :intentname="intent.intentname"
                    :showMultipleChannel="showMultipleChannel"
                    :channel="tab"
                    @changeSetting="changeSetting"
                  ></intent-group>
                </template>
                <template v-else>
                  <template v-if="tab == 'facebook'">
                    <intent-group
                      key="fb_message"
                      v-model="fb_messages"
                      :intentname="intent.intentname"
                      :showMultipleChannel="showMultipleChannel"
                      :channel="tab"
                      @changeSetting="changeSetting"
                    ></intent-group>
                  </template>
                  <template v-else-if="tab == 'line'">
                    <intent-group
                      key="line_message"
                      v-model="line_messages"
                      :intentname="intent.intentname"
                      :showMultipleChannel="showMultipleChannel"
                      @changeSetting="changeSetting"
                    ></intent-group>
                  </template>
                </template>
              </v-flex>
            </v-layout>
            <template v-if="!isWelcome && !isCommentToInbox">
              <div class="hr"></div>
              <p class="small" style="margin-top: 10px">{{ $t('Choice') }}</p>

              <div class="form-control" :class="{ 'has-error': errorTag.length > 0 }">
                <tags
                  v-model="reply"
                  :tags="replies"
                  @tags-changed="addReplies"
                  @before-adding-tag="checkQuickReply"
                  style="margin-bottom: 5px"
                  :btnText="$t('Add choice')"
                ></tags>
                <!-- <vue-tags-input v-model="reply" :tags="replies" @tags-changed="newTags => replies = newTags" @before-adding-tag="checkQuickReply" /> -->
                <span class="text-error" v-if="errorTag.length > 0">
                  <template v-if="errorTag.includes('overmaxlength')">{{
                    $t('Message cannot be longer than 20 alphabets')
                  }}</template>
                  <template v-else-if="errorTag.includes('overtagmax')">{{
                    $t('Choices cannot be more than 10 items')
                  }}</template>
                  <template v-else-if="errorTag.includes('duplicate')">{{
                    $t('Duplicate Choice')
                  }}</template>
                </span>
              </div>
            </template>
            <template v-else></template>
          </template>
        </v-flex>
      </v-layout>

      <div class="mt-4">
        <div class="hr"></div>
        <div class="text-xs-center" style="margin: -13px">
          <a
            class="text btn-advanced"
            href="javascript:void(0);"
            @click="onShowAdvance"
            style="position: relative"
          >
            {{ $t('Advanced') }}
            <i
              class="fa"
              :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }"
            ></i>
          </a>
        </div>

        <template>
          <div
            style="margin-top: 25px"
            v-show="showAdvanced || errors.has('context_in') || errors.has('startdate')"
          >
            <v-tabs v-model="advancedTab" slider-color="primary" touchless>
              <v-tab :key="0" ripple>{{ $t('Customer') }}</v-tab>
              <v-tab v-if="!isCommentToInbox && !isLiveStream" :key="1" ripple>
                {{ $t('Context') }}
              </v-tab>
              <v-tab :key="2" ripple>{{ $t('Timer') }}</v-tab>
              <v-tab :key="3" ripple>{{ $t('Line Notify') }}</v-tab>
              <v-tab
                :key="4"
                v-show="
                  false &&
                    isCommentToInbox &&
                    !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname)
                "
                ripple
                >{{ $t('Limit reply to inbox')
                }}<v-chip disabled small class="white--text" color="info">Beta</v-chip></v-tab
              >

              <v-tab
                v-show="!isCommentToInbox"
                :value="5"
                :key="5"
                ripple
                v-if="selectedBot.theme == 'ticket'"
              >
                {{ $t('Intent Group') }}
              </v-tab>

              <v-tab-item :key="0">
                <v-card
                  flat
                  :style="{
                    'min-height': $store.getters.getPackage != 'premium' ? '250px' : ''
                  }"
                >
                  <v-premium-plan-popup
                    :showAll="false"
                    v-if="$store.getters.getPackage != 'premium'"
                  ></v-premium-plan-popup>
                  <v-card-text>
                    <div class="form-control">
                      <div class="primary--text caption">{{ $t('Status') }}</div>
                      <input
                        type="text"
                        class="form-control"
                        :placeholder="$t('Status')"
                        v-model="intent.userstatus"
                        maxlength="600"
                      />
                    </div>
                    <div>
                      <div class="primary--text caption mb-2">{{ $t('Tag') }}</div>
                      <tags
                        v-model="usertag"
                        :tags="usertags"
                        @tags-changed="addUserTags"
                        @before-adding-tag="checkUserTags"
                        style="margin-bottom: 5px"
                        :btnText="$t('Add tag')"
                      ></tags>
                      <div class="caption">
                        {{ $t('Learn more') }}
                        <a
                          href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%95%e0%b8%b4%e0%b8%94%e0%b8%aa%e0%b8%96%e0%b8%b2%e0%b8%99%e0%b8%b0status-%e0%b8%9b%e0%b9%89%e0%b8%b2%e0%b8%a2%e0%b8%81%e0%b8%b3%e0%b8%81%e0%b8%b1%e0%b8%9atag/"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ $t('click here') }}</a
                        >
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="!isCommentToInbox && !isLiveStream" :key="1">
                <v-card
                  flat
                  :style="{
                    'min-height': $store.getters.getPackage != 'premium' ? '250px' : ''
                  }"
                >
                  <v-premium-plan-popup
                    :showAll="false"
                    v-if="$store.getters.getPackage != 'premium'"
                  ></v-premium-plan-popup>
                  <v-card-text>
                    <v-layout>
                      <v-flex
                        class="form-control pr-1"
                        :class="{ 'has-error': errors.has('context_in') }"
                      >
                        <template v-if="isLiveStream">
                          <input
                            type="text"
                            class="form-control"
                            :value="$t('facebooklive')"
                            readonly
                            disabled
                          />
                        </template>
                        <template v-else-if="isCommentToInbox">
                          <input
                            type="text"
                            class="form-control"
                            :value="$t('Comment')"
                            readonly
                            disabled
                          />
                        </template>
                        <template v-else>
                          <input
                            style="margin-bottom: 5px"
                            type="text"
                            class="form-control"
                            placeholder="Context In"
                            data-vv-as="Context In"
                            name="context_in"
                            v-model="intent.context_in"
                            v-validate="!isCommentToInbox ? 'excluded:comment' : ''"
                          />
                          <span class="text-error" v-show="errors.has('context_in')">{{
                            $t('Context In cannot be Comment')
                          }}</span>
                        </template>
                      </v-flex>
                      <v-flex class="form-control pl-1">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Context Out"
                          v-model="intent.context_out"
                        />
                      </v-flex>
                    </v-layout>
                    <div class="caption">
                      {{ $t('Learn more') }}
                      <a
                        href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b9%83%e0%b8%8a%e0%b9%89-context/"
                        target="_blank"
                        rel="noopener noreferrer"
                        >{{ $t('click here') }}</a
                      >
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="2">
                <v-card
                  flat
                  :style="{
                    'min-height': $store.getters.getPackage != 'premium' ? '250px' : '',
                    'background-color': $store.getters.getPackage != 'premium' ? 'red' : 'blue'
                  }"
                >
                  <v-premium-plan-popup
                    :showAll="false"
                    v-if="$store.getters.getPackage != 'premium'"
                  ></v-premium-plan-popup>
                  <v-card-text>
                    <v-radio-group @change="changeOnlytime" v-model="intent.onlytime">
                      <v-radio
                        :color="'primary'"
                        :label="$t(`Turn On/Off Date & Time Setting for Bot's Reply`)"
                        :value="false"
                      ></v-radio>
                      <v-radio
                        :color="'primary'"
                        :label="$t(`Selecting certain chatbot's answers for the certain time`)"
                        :value="true"
                      ></v-radio>
                    </v-radio-group>
                    <v-layout v-if="intent.onlytime">
                      <v-flex class="pr-1">
                        <div class="form-control">
                          <div class="caption">{{ $t('Turn-on Time') }}</div>
                          <v-layout wrap>
                            <v-flex xs10 class="pl-1">
                              <v-menu
                                ref="openStartTime"
                                v-model="openStartTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="startTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="startTime"
                                    v-on="on"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openStartTime"
                                  v-model="startTime"
                                  full-width
                                  @click:minute="$refs.openStartTime.save(startTime)"
                                ></v-time-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs2>
                              <v-btn
                                fab
                                flat
                                small
                                color="primary"
                                style="height: 35px; width: 35px"
                                @click="
                                  startDate = null
                                  startTime = null
                                "
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                      <v-flex class="pl-1">
                        <div class="form-control">
                          <div class="caption">{{ $t('Turn-off Time') }}</div>
                          <v-layout wrap>
                            <v-flex xs10 class="pl-1">
                              <v-menu
                                ref="openEndTime"
                                v-model="openEndTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="endTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="endTime"
                                    v-on="on"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openEndTime"
                                  v-model="endTime"
                                  full-width
                                  @click:minute="$refs.openEndTime.save(endTime)"
                                ></v-time-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs2>
                              <v-btn
                                fab
                                flat
                                small
                                color="primary"
                                style="height: 35px; width: 35px"
                                @click="
                                  endDate = null
                                  endTime = null
                                "
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout v-else>
                      <v-flex class="pr-1">
                        <div class="form-control">
                          <div class="caption">{{ $t('Turn-on Time') }}</div>
                          <v-layout wrap>
                            <v-flex
                              xs6
                              class="form-control"
                              :class="{ 'has-error': errors.has('startdate') }"
                            >
                              <v-menu
                                ref="openStartDate"
                                v-model="openStartDate"
                                :close-on-content-click="false"
                                full-width
                                max-width="290px"
                                color="primary"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Date')"
                                    readonly
                                    v-model="startDate"
                                    v-on="on"
                                    clearable
                                  />
                                </template>
                                <v-date-picker
                                  color="primary"
                                  v-model="startDate"
                                  @input="openStartDate = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs4 class="pl-1">
                              <v-menu
                                ref="openStartTime"
                                v-model="openStartTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="startTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                                :disabled="startDate == null"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="startTime"
                                    v-on="on"
                                    :disabled="startDate == null"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openStartTime"
                                  v-model="startTime"
                                  full-width
                                  @click:minute="$refs.openStartTime.save(startTime)"
                                ></v-time-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs2>
                              <v-btn
                                fab
                                flat
                                small
                                color="primary"
                                style="height: 35px; width: 35px"
                                @click="
                                  startDate = null
                                  startTime = null
                                "
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                      <v-flex class="pl-1">
                        <div class="form-control">
                          <div class="caption">{{ $t('Turn-off Time') }}</div>
                          <v-layout wrap>
                            <v-flex
                              class="form-control"
                              xs6
                              :class="{ 'has-error': errors.has('enddate') }"
                            >
                              <v-menu
                                ref="openEndDate"
                                v-model="openEndDate"
                                :close-on-content-click="false"
                                full-width
                                max-width="290px"
                                color="primary"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Date')"
                                    readonly
                                    v-model="endDate"
                                    v-on="on"
                                    clearable
                                  />
                                </template>
                                <v-date-picker
                                  color="primary"
                                  v-model="endDate"
                                  @input="openEndDate = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs4 class="pl-1">
                              <v-menu
                                ref="openEndTime"
                                v-model="openEndTime"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="endTime"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                max-width="290px"
                                min-width="290px"
                                :disabled="endDate == null"
                              >
                                <template v-slot:activator="{ on }">
                                  <input
                                    type="text"
                                    class="form-control browser-default"
                                    :placeholder="$t('Time')"
                                    readonly
                                    v-model="endTime"
                                    v-on="on"
                                    :disabled="endDate == null"
                                  />
                                </template>
                                <v-time-picker
                                  v-if="openEndTime"
                                  v-model="endTime"
                                  full-width
                                  @click:minute="$refs.openEndTime.save(endTime)"
                                ></v-time-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs2>
                              <v-btn
                                fab
                                flat
                                small
                                color="primary"
                                style="height: 35px; width: 35px"
                                @click="
                                  endDate = null
                                  endTime = null
                                "
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </div>
                      </v-flex>
                    </v-layout>

                    <div class="form-control" :class="{ 'has-error': errors.has('startdate') }">
                      <input
                        v-model="startTimeFormat"
                        type="hidden"
                        :data-vv-as="$t('Start date')"
                        name="startdate"
                        v-validate="endTimeFormat ? '' : ''"
                      />
                      <input
                        :data-vv-as="$t('End date')"
                        name="enddate"
                        v-model="endTimeFormat"
                        type="hidden"
                        ref="beforeTarget"
                      />

                      <span class="text-error" v-if="errors.has('startdate')">
                        {{ errors.first('startdate') }}
                      </span>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="3">
                <v-card
                  flat
                  :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '250px' : '' }"
                >
                  <v-premium-plan-popup
                    :showAll="false"
                    v-if="$store.getters.getPackage != 'premium'"
                  ></v-premium-plan-popup>
                  <v-card-text>
                    <div class="col s8">
                      <div class="primary--text caption">{{ $t('Line Notify') }}</div>
                    </div>
                    <div class="col s4 right-align">
                      <template v-if="$store.state.linenotifylist.length == 0"></template>
                      <template
                        v-else-if="
                          (selectedBot.notify_intent && !isCommentToInbox) ||
                            (selectedBot.notify_comment && isCommentToInbox)
                        "
                      >
                        <label
                          class="toggle-switch small"
                          style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
                        >
                          <input
                            type="checkbox"
                            :checked="intent.linenoti_status"
                            @change="toggleLineNotifyStatus"
                          />
                          <span class="toggle-slider lever round"></span>
                        </label>
                      </template>
                    </div>
                    <div class="col s12 form-control">
                      <template v-if="$store.state.linenotifylist.length == 0">
                        {{ $t('You are not connected to Line Notify.') }}
                        <router-link to="billing">{{
                          $t('Click to connected Line Notify at the settings page')
                        }}</router-link>
                      </template>
                      <template
                        v-else-if="
                          (selectedBot.notify_intent && !isCommentToInbox) ||
                            (selectedBot.notify_comment && isCommentToInbox)
                        "
                      >
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('Message')"
                          maxlength="250"
                          v-model="intent.linenoti_text"
                        />
                      </template>
                      <template v-else>
                        {{ $t('Not yet alert via Line Notify.') }}
                        <router-link to="billing">{{
                          $t('Click to connected Line Notify at the settings page')
                        }}</router-link>
                      </template>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="4">
                <v-card
                  flat
                  :style="{ 'min-height': $store.getters.getPackage != 'premium' ? '250px' : '' }"
                >
                  <v-premium-plan-popup
                    :showAll="false"
                    v-if="$store.getters.getPackage != 'premium'"
                  ></v-premium-plan-popup>
                  <v-card-text>
                    <div
                      class="py-1 px-3 info white--text caption"
                      style="border-radius: 25px; display: inline-block"
                    >
                      ฟีเจอร์นี้ยังอยู่ในระหว่างการทดลอง Beta เปิดให้ใช้งานชั่วคราว
                    </div>

                    <div class="col s12 form-control">
                      <v-checkbox
                        v-model="isremainingreply"
                        color="primary"
                        :label="$t('Reply to comment (amount)')"
                        hide-details
                        @change="changeRemainingReply"
                      ></v-checkbox>
                      <input
                        type="number"
                        class="mt-2"
                        v-model="remaining_reply"
                        :disabled="!isremainingreply"
                        :placeholder="$t('Amount2')"
                      />
                      <v-checkbox
                        v-model="notreplysameperson"
                        color="primary"
                        :label="$t('Reply once/person')"
                        hide-details
                      ></v-checkbox>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="5">
                <v-card v-if="advancedTab && advancedTab == 5" flat>
                  <v-card-text>
                    <template v-if="selectedBot.theme == 'ticket'">
                      <div>
                        <v-layout row wrap>
                          <v-flex
                            xs12
                            sm6
                            class="form-control px-1 pb-2"
                            :class="{ 'has-error': errors.has('group') }"
                          >
                            <div class="caption mb-1 mt-2">Group *</div>
                            <multiselect
                              v-model="ticket.group"
                              :options="agentGroup"
                              track-by="groupname"
                              label="groupname"
                              name="group"
                              :searchable="true"
                              selectLabel
                              selectedLabel
                              deselect-label
                              @input="onChangeGroup"
                            ></multiselect>
                            <p class="text-error" v-if="errors.has('group')">
                              {{ errors.first('group') }}
                            </p>
                          </v-flex>
                          <v-flex xs12 sm6 class="form-control px-1 pb-2" v-if="ticket.group">
                            <div class="caption mb-1 mt-2">Subgroup</div>
                            <v-layout>
                              <multiselect
                                v-model="ticket.subgroup"
                                :options="filterSubGroup"
                                track-by="subgroupname"
                                label="subgroupname"
                                :searchable="true"
                                selectLabel
                                selectedLabel
                                deselect-label
                              ></multiselect>
                              <v-btn small flat fab class="my-0" @click="ticket.subgroup = null">
                                <v-icon>close</v-icon>
                              </v-btn>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <div class="caption mb-1 mt-2">Priority *</div>
                            <multiselect
                              class="mb-3"
                              v-model="ticket.priority"
                              :key="`priority`"
                              :options="priorityOptions"
                              label="text"
                              selectLabel
                              selectedLabel
                              :allow-empty="false"
                              :searchable="false"
                              deselect-label
                              track-by="text"
                            ></multiselect>
                          </v-flex>
                          <v-flex xs12>
                            <div class="caption mb-1 mt-2">Tags</div>
                            <v-combobox
                              v-model="ticket.tags"
                              :filter="tagsfilter"
                              :hide-no-data="!tagssearch"
                              :items="tagitems"
                              :search-input.sync="tagssearch"
                              hide-selected
                              label="Search for an option"
                              multiple
                              small-chips
                              solo
                            >
                              <template v-slot:no-data>
                                <v-list-tile>
                                  <span class="subheading">Create</span>
                                  <v-chip :color="`primary lighten-3`" label small>{{
                                    tagssearch
                                  }}</v-chip>
                                </v-list-tile>
                              </template>
                              <template v-slot:selection="{ item, parent, selected }">
                                <v-chip
                                  v-if="item === Object(item)"
                                  :color="`primary lighten-3`"
                                  :selected="selected"
                                  label
                                  small
                                >
                                  <span class="pr-2">{{ item.text }}</span>
                                  <v-icon small @click="parent.selectItem(item)">close</v-icon>
                                </v-chip>
                              </template>
                              <template v-slot:item="{ index, item }">
                                <v-list-tile-content>
                                  <v-text-field
                                    v-if="tagediting === item"
                                    v-model="tagediting.text"
                                    autofocus
                                    flat
                                    background-color="transparent"
                                    hide-details
                                    solo
                                    @keyup.enter="tagsedit(index, item)"
                                  ></v-text-field>
                                  <v-chip v-else :color="`primary lighten-3`" dark label small>{{
                                    item.text
                                  }}</v-chip>
                                </v-list-tile-content>
                                <v-spacer></v-spacer>
                                <v-list-tile-action @click.stop>
                                  <v-btn icon @click.stop.prevent="tagsedit(index, item)">
                                    <v-icon>{{ tagediting !== item ? 'edit' : 'check' }}</v-icon>
                                  </v-btn>
                                </v-list-tile-action>
                              </template>
                            </v-combobox>
                          </v-flex>
                        </v-layout>
                        <div>Due Date</div>
                        <v-divider></v-divider>
                        <v-layout wrap style="margin-top: 24px">
                          <v-flex xs4 class="px-1 form-control">
                            <div class="caption">Day</div>
                            <input
                              @input="ticket.day = numberOnly($event, 'day')"
                              placeholder="Days"
                              v-model.number="ticket.day"
                              type="text"
                            />
                          </v-flex>
                          <v-flex xs4 class="px-1 form-control">
                            <div class="caption">Hour</div>
                            <input
                              @input="ticket.hour = numberOnly($event, 'hour')"
                              placeholder="Hour"
                              v-model.number="ticket.hour"
                              type="text"
                            />
                          </v-flex>
                          <v-flex
                            xs4
                            class="px-1 form-control"
                            :class="{ 'has-error': errors.has('Minute') }"
                          >
                            <div class="caption">Minute</div>
                            <input
                              name="Minute"
                              @input="ticket.minute = numberOnly($event, 'minute')"
                              placeholder="Minute"
                              v-validate="'max_value:59'"
                              v-model.number="ticket.minute"
                              type="text"
                            />
                            <p class="text-error" v-if="errors.has('Minute')">
                              {{ errors.first('Minute') }}
                            </p>
                          </v-flex>
                        </v-layout>
                      </div>
                    </template>
                    <template v-else>
                      <div>
                        <div class="form-control">
                          <div class="primary--text caption">{{ $t('Intent Group') }}</div>
                          <input
                            type="text"
                            class="form-control"
                            :placeholder="$t('Intent Group')"
                            v-model="intent.intentgroup"
                            maxlength="600"
                          />
                        </div>
                      </div>
                    </template>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </div>
        </template>
      </div>

      <div class="text-xs-center" style="margin-top: 35px; margin-bottom: 15px">
        <template>
          <input
            type="hidden"
            v-model="intent.q_val"
            v-validate="
              !['{default}', '{default_comment_to_inbox}'].includes(intent.intentname)
                ? 'required'
                : ''
            "
            :data-vv-as="$t('customer says')"
            name="q_val"
          />
          <div class="form-control has-error" style="margin-bottom: 10px">
            <span class="text-error" v-if="errors.has('intentName')">{{
              errors.first('intentName')
            }}</span>
            <span class="text-error" v-else-if="errors.has('q_val')">{{
              errors.first('q_val')
            }}</span>
            <span class="text-error" v-else-if="errors.has('bubbleLimit')">{{
              errors.first('bubbleLimit')
            }}</span>
            <span class="text-error" v-else-if="errorTag.length > 0">
              <template v-if="errorTag.includes('overmaxlength')">{{
                $t('Message cannot be longer than 20 alphabets')
              }}</template>
              <template v-else-if="errorTag.includes('overtagmax')">{{
                $t('Choices cannot be more than 10 items')
              }}</template>
              <template v-else-if="errorTag.includes('duplicate')">{{
                $t('Duplicate Choice')
              }}</template>
            </span>
            <span class="text-error" v-else-if="errorUserTags.length > 0">
              <template v-if="errorUserTags.includes('duplicate')">{{
                $t('Duplicate Tag')
              }}</template>
            </span>

            <span class="text-error" v-else-if="errors.has('context_in')">{{
              $t('Context In cannot be Comment')
            }}</span>
            <span class="text-error" v-else-if="errors.has('startdate')">{{
              errors.first('startdate')
            }}</span>
          </div>
          <slot name="footer" :saveIntent="saveIntent" :cancelEdit="cancelEdit">
            <div style="margin-bottom: 15px">
              <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
                <i class="far fa-eye"></i>
                {{ $t('preview') }}
              </a>
              <preview-message
                v-if="showPreview"
                @close="showPreview = false"
                :messages="messages"
                :choice="replies"
                :questions="questions"
                :isComment="isCommentToInbox"
                :comment="replyComment"
              ></preview-message>
            </div>
            <v-btn outline color="grey" @click="cancelEdit">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" @click="saveIntent">{{ $t('Save') }}</v-btn>
          </slot>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import VueTagsInput from '@johmun/vue-tags-input'
import uploadfile from '@/components/elements/uploadfile'
import IntentGroup from './IntentGroup'
import IntentComment from './IntentComment'
import IntentGetstarted from './IntentGetstarted'
import Draggable from 'vuedraggable'
import GenericManage from '@/components/elements/GenericManage'
import MoveHorizontal from '@/components/elements/MoveHorizontal'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import IntentPrefill from './IntentPrefill'

import ModalDialog from '@/components/elements/ModalDialog'
import ModalBlank from '@/components/elements/ModalBlank'
import Tags from '@/components/elements/Tags'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import PreviewMessage from '@/components/elements/PreviewMessage'
import IntentSelectPost from './IntentSelectPost'
import IntentQuestion from './IntentQuestion'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import datepicker from 'vuejs-datepicker'

import { VueAutosuggest } from 'vue-autosuggest'
import { ToggleButton } from 'vue-js-toggle-button'

const dict = {
  en: {
    custom: {
      intentName: {
        excluded: 'Duplicate Conversation Name',
        excludednew: 'Duplicate Conversation Name'
      }
    }
  },
  th: {
    custom: {
      intentName: {
        excluded: 'ชื่อบทสนทนาซ้ำ',
        excludednew: 'ชื่อบทสนทนาซ้ำ'
      }
    }
  },
  la: {
    custom: {
      intentName: {
        excluded: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ',
        excludednew: 'ເຮັດຊ້ໍາຊື່ການສົນທະນາ'
      }
    }
  }
}

export default {
  props: {
    value: {
      type: Object
    },
    type: {
      type: String,
      default: 'add'
    },
    isDefault: {
      type: Boolean,
      default: false
    },
    isWelcome: {
      type: Boolean,
      default: false
    },
    excludedIntentName: {
      type: String,
      default: ''
    },
    isCommentToInbox: {
      type: Boolean,
      default: false
    },
    isLiveStream: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VueTagsInput,
    uploadfile,
    IntentGroup,
    IntentComment,
    IntentGetstarted,
    Draggable,
    GenericManage,
    MoveHorizontal,
    AutoresizeTextarea,
    IntentPrefill,

    ModalDialog,
    ModalBlank,
    Tags,
    PreviewMessage,
    ViewCartSummaryViewer,
    VueAutosuggest,
    IntentSelectPost,
    IntentQuestion,
    Multiselect,
    ToggleButton,
    datepicker
  },
  data: function() {
    return {
      tagssearch: null,
      showDueTimeDialog: false,
      priorityOptions: [
        {
          text: 'Low',
          value: 'low'
        },
        {
          text: 'Medium',
          value: 'medium'
        },
        {
          text: 'High',
          value: 'high'
        }
      ],
      tab: 'facebook',
      showMultipleChannel: false,
      tagediting: null,
      postidlist: { includes: [], excludes: [] },
      advancedTab: null,
      showSelectPost: false,
      showAdvanced: false,
      showPreview: false,
      intent: undefined,

      startDate: null,
      startTime: null,
      openStartDate: false,
      openStartTime: false,
      endDate: null,
      endTime: null,
      openEndDate: false,
      openEndTime: false,

      tag: '',
      usertag: '',
      groups: [],
      generics: [],
      quick_reply: '',
      reply: '',
      text: '',
      messages: [[]],
      fb_messages: [[]],
      line_messages: [[]],

      errorTag: [],
      errorUserTags: [],
      errorQuestionTag: [],

      isReplyComment: false,
      replyComment: '',
      showEmoji: false,
      excludedName: '',
      intents: [],

      selected: '',
      filteredOptions: [],
      inputProps: {
        id: 'autosuggest__input',
        onInputChange: this.onInputChange,
        placeholder: "Type 'e'"
      },
      limit: 10,
      isremainingreply: false,
      remaining_reply: null,
      notreplysameperson: false,
      ticket: {
        assigngroupid: '',
        assignsubgroupid: '',
        priority: '',
        group: '',
        subgroup: '',
        tags: [],
        day: 0,
        hour: 0,
        minute: 0,
        duedate: {
          start: '',
          starttime: '',
          end: ''
        }
      },
      tagitems: [{ header: 'Select an option or create one' }],
      limit: 10,
      showDueDate: false,
      timestamp: moment().format('x')
    }
  },
  created: function() {
    var vm = this
    vm.$validator.extend('earlier', {
      getMessage(field, val) {
        return vm.$t('The {field} must be before or equal.', { field: field })
      },
      validate(value, field) {
        if (vm.startTimeFormat || vm.endTimeFormat) {
          var isafter = moment(vm.startTimeFormat).isAfter(vm.endTimeFormat)
          return !isafter
        } else {
          return true
        }
      }
    })
  },
  mounted: function() {
    let vm = this

    vm.$validator.localize(dict)
    vm.$validator.localize(this.currentLang)

    vm.intent = Object.assign({}, vm.value)
    if (!vm.intent.postidlist) {
      vm.intent.postidlist = ''
    } else {
      var includes = []
      if (vm.intent.postidlist && vm.intent.postidlist !== '') {
        try {
          includes = JSON.parse(vm.intent.postidlist)
        } catch (error) {
          includes = vm.intent.postidlist.split(',')
        }
      }
      this.$set(this.postidlist, 'includes', includes)
    }
    if (vm.intent.fb_val || vm.intent.line_val) {
      this.showMultipleChannel = true
      this.fb_messages = JSON.parse(vm.intent.fb_val)
      this.line_messages = JSON.parse(vm.intent.line_val)
    }
    this.timestamp = moment().format('x')

    if (vm.isCommentToInbox) {
      vm.remaining_reply = vm.intent.remaining_reply
      vm.notreplysameperson = vm.intent.notreplysameperson
      vm.isremainingreply = vm.intent.remaining_reply != null
    }

    if (!vm.intent.exceptpostidlist) {
      vm.intent.exceptpostidlist = ''
    } else {
      var excludes = []
      if (vm.intent.exceptpostidlist && vm.intent.exceptpostidlist !== '') {
        try {
          excludes = JSON.parse(vm.intent.exceptpostidlist)
        } catch (error) {
          excludes = vm.intent.exceptpostidlist.split(',')
        }
      }
      this.$set(this.postidlist, 'excludes', excludes)
    }
    vm.cached_intent = Object.assign({}, vm.value)

    if (vm.intent.starttime) {
      var startTime = moment(vm.intent.starttime)
      vm.startDate = startTime.format('YYYY-MM-DD')
      vm.startTime = startTime.format('HH:mm')
    }
    if (vm.intent.endtime) {
      var endTime = moment(vm.intent.endtime)
      vm.endDate = endTime.format('YYYY-MM-DD')
      vm.endTime = endTime.format('HH:mm')
    }

    vm.intents = vm.excludedIntentName.split(',')
    vm.intents.push('comment')
    vm.intents.push('{default}')
    vm.intents.push('{welcome}')
    vm.intents.push('{default_comment_to_inbox}')

    vm.intent.onlytime = vm.intent.onlytime ? vm.intent.onlytime : false

    if (vm.isCommentToInbox && !vm.isLiveStream) {
      vm.isReplyComment = true
      vm.intent.context_in = 'comment'
    } else if (vm.isLiveStream) {
      vm.intent.context_in = 'facebooklive'
    }
    var names = []
    if (vm.type === 'edit' && vm.excludedIntentName && vm.excludedIntentName !== '' && vm.intent) {
      names = vm.intents
      $.each(names, function(index, name) {
        if (name === vm.intent.intentname) {
          names.splice(index, 1)
          return false
        }
      })

      names = names.map(el => {
        return el.replace(/,/g, '')
      })

      vm.excludedName = names.join(',').replace(/[|]/g, '//#or//')
    } else {
      names = vm.intents.map(el => {
        return el.replace(/,/g, '')
      })

      vm.excludedName = names.join(',').replace(/[|]/g, '//#or//')
    }

    if (vm.value.context_in === 'comment') {
      if (vm.value.a_type === 'json') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          var message = JSON.parse(vm.value.a_val)
          if (message[0][0].type === 'text') {
            vm.messages = [
              [
                {
                  type: 'responsepost',
                  replyinbox: true,
                  replycomment: false,
                  hidecomment: false,
                  responseinbox: [
                    {
                      type: 'text',
                      text: message[0][0].text
                    }
                  ],
                  responsecomment: [
                    {
                      type: 'text',
                      text: ''
                    }
                  ]
                }
              ]
            ]
          } else if (message[0][0].type === 'responsepost') {
            vm.messages = message
          }
        } else {
          vm.messages = [
            [
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: vm.value.a_val
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ]
          ]
        }
      } else {
        vm.messages = [
          [
            {
              type: 'responsepost',
              replyinbox: true,
              replycomment: false,
              hidecomment: false,
              responseinbox: [
                {
                  type: 'text',
                  text: vm.value.a_val
                }
              ],
              responsecomment: [
                {
                  type: 'text',
                  text: ''
                }
              ]
            }
          ]
        ]
      }
    } else if (vm.value.a_type === 'json') {
      if (vm.isJsonParseable(vm.value.a_val)) {
        vm.messages = JSON.parse(vm.value.a_val)
      } else {
        vm.messages = [[]]
      }
    } else {
      if (vm.value.a_val === '{welcome_message}') {
        vm.messages = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (vm.value.a_type === 'text') {
        var newGroup = []
        var group = vm.value.a_val.split('||')
        $.each(group, function(index, messages) {
          var newMessage = []
          var groupMessages = messages.split('#nl')
          $.each(groupMessages, function(index, message) {
            var type = 'text'
            if (!isNaN(message)) {
              newMessage.push({
                type: 'text',
                text: message
              })
            } else if (vm.isJsonParseable(message)) {
              var messageParsed = JSON.parse(message)
              newMessage.push({
                text: messageParsed.text,
                buttons: messageParsed.buttons,
                type: 'button'
              })
            } else if (vm.isURL(message)) {
              newMessage.push({
                type: 'image',
                image_url: message
              })
            } else {
              newMessage.push({
                type: 'text',
                text: message
              })
            }
          })
          newGroup.push(newMessage)
        })
        vm.messages = newGroup
      } else if (vm.value.a_type === 'message') {
        vm.messages = [
          [
            {
              type: 'text',
              data: vm.value.a_val
            }
          ]
        ]
      } else if (vm.value.a_type === 'template') {
        vm.messages = [
          [
            {
              type: 'generic',
              data: JSON.parse(vm.value.a_val),
              ratio: vm.value.ratio == 'horizontal' ? 'horizontal' : 'square'
            }
          ]
        ]
      } else if (vm.value.a_type === 'message') {
      } else if (vm.value.a_type === 'generic') {
      } else if (vm.value.a_type === 'viewsummary') {
        vm.messages = [
          [
            {
              type: 'text',
              text: '{viewsummary}'
            }
          ]
        ]
      }
    }
    if (this.selectedBot.theme == 'ticket') {
      this.ticketinit()
    }
  },
  computed: {
    tickettags() {
      return this.ticket.tags
    },
    isReadonly() {
      return false
    },
    filterSubGroup() {
      if (this.ticket.group) {
        return this.agentSubGroup.filter(el => {
          return el.admingroupid == this.ticket.group.id
        })
      } else {
        return []
      }
    },
    showReplyCommentSelectPost() {
      return this.isReplyComment && this.isCommentToInbox && !this.isLiveStream
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      welcomeMessage: 'welcomeMessage',
      setting: 'setting',
      currentLang: 'currentLang',

      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup'
    }),
    areaName: function() {
      var areaName = ['ทุกพื้นที่'].concat(this.$store.state.uuAreaName)
      return areaName
    },
    tags: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.q_val && vm.intent.q_val !== '') {
          var tags = vm.intent.q_val.split(',')
          var result = []
          try {
            result = tags(function(val) {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        try {
          result = value.map(function(val) {
            return val.text
          })
        } catch (error) {}
        vm.intent.q_val = result.join(',')
      }
    },
    replies: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.quick_reply && vm.intent.quick_reply !== '') {
          // console.log(vm.intent.quick_reply)
          var quick_replies = []

          if (vm.value.a_type === 'message' || vm.value.a_type === 'generic') {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = vm.intent.quick_reply.split(',')
          }
          var result = []
          try {
            result = quick_replies.map(val => {
              return { text: val }
            })
          } catch (error) {}
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map(el => {
            return el.text
          })
        } catch (error) {}
        this.$set(this.intent, 'quick_reply', result.join(','))
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.intent && vm.intent.usertags && vm.intent.usertags !== '') {
          var usertags = []

          usertags = vm.intent.usertags.split(',')
          var result = []
          if (usertags) {
            try {
              result = usertags.map(function(tag) {
                return { text: tag }
              })
            } catch (error) {}
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        if (value) {
          result = value.map(function(tag) {
            return tag.text
          })
        }

        this.$set(this.intent, 'usertags', result.join(','))
      }
    },
    questions: function() {
      var result = []
      try {
        var questions = this.formatQuestionData(this.intent.q_val)
        if (questions.normal) {
          result = questions.normal.map(el => {
            return el.text
          })
        } else if (questions.keyword) {
          result = questions.keyword.map(el => {
            return el.text
          })
        } else if (questions.exactly) {
          result = questions.exactly.map(el => {
            return el.text
          })
        } else if (questions.startwith) {
          result = questions.startwith.map(el => {
            return el.text
          })
        } else if (questions.endwith) {
          result = questions.endwith.map(el => {
            return el.text
          })
        } else if (questions.startandendwith) {
          result = questions.startandendwith.map(el => {
            return el.text
          })
        }
        // result = questions.map(function(val) {
        //   return val.text
        // })
      } catch (error) {
        console.log(error)
      }
      return result
    },
    startTimeFormat: function() {
      var time = null
      var vm = this
      if (this.intent.onlytime) {
        if (vm.startTime) time = moment().format('YYYY-MM-DD') + ' ' + vm.startTime + ':00'
        else time = moment().format('YYYY-MM-DD') + ' 00:00:00'
      } else if (vm.startDate) {
        if (vm.startTime) {
          time = vm.startDate + ' ' + vm.startTime + ':00'
        } else {
          time = vm.startDate + ' 00:00:00'
        }
      }
      return time
    },
    endTimeFormat: function() {
      var time = null
      var vm = this
      if (this.intent.onlytime) {
        if (vm.endTime) time = moment().format('YYYY-MM-DD') + ' ' + vm.endTime + ':00'
        else time = moment().format('YYYY-MM-DD') + ' 23:59:00'
      } else if (vm.endDate) {
        if (vm.endTime) {
          time = vm.endDate + ' ' + vm.endTime + ':00'
        } else {
          time = vm.endDate + ' 23:59:00'
        }
      }
      return time
    },
    intentgroup() {
      var hasValue = val => (val && val.length ? val : null)
      var duedate = null
      if (this.ticket.duedate.start) {
        duedate = moment(this.ticket.duedate.start).format('YYYY-MM-DD')
        if (this.ticket.duedate.starttime) {
          duedate = duedate + ' ' + this.ticket.duedate.starttime
        } else {
          duedate = duedate + ' 00:00'
        }
      }
      return {
        assigngroupid: hasValue(this.ticket.group ? this.ticket.group.id : null),
        assignsubgroupid: hasValue(this.ticket.subgroup ? this.ticket.subgroup.id : null),
        priority: hasValue(this.ticket.priority ? this.ticket.priority.value : null),
        duedate: duedate,
        day: this.ticket.day ? this.ticket.day : null,
        hour: this.ticket.hour ? this.ticket.hour : null,
        minute: this.ticket.minute ? this.ticket.minute : null,

        tags:
          this.ticket.tags && this.ticket.tags.length
            ? this.ticket.tags.map(el => el.text).join(',')
            : null
      }
    }
  },

  methods: {
    changeSetting(payload) {
      if (
        (this.$store.getters.getPackage == 'premium' ||
          this.selectedBot.pagetype == 'enterprise') &&
        payload.hasOwnProperty('showMultipleChannel')
      ) {
        if (
          this.showMultipleChannel != payload.showMultipleChannel &&
          payload.showMultipleChannel == true
        ) {
          this.fb_messages = _.cloneDeep(this.messages)
          this.line_messages = _.cloneDeep(this.messages)
        }
        this.showMultipleChannel = payload.showMultipleChannel
      }
    },
    changeRemainingReply(value) {
      if (value) {
        this.remaining_reply = 0
      } else {
        this.remaining_reply = null
      }
    },
    formatQuestionData: function(text) {
      var questions = text && text !== '' ? text.split(',') : []
      var result = {
        normal: [],
        keyword: [],
        exactly: [],
        startwith: [],
        endwith: [],
        startandendwith: []
      }
      if (questions) {
        questions.forEach(function(question) {
          var pointer = null
          var keyword = null
          if (question.startsWith('startswith(') && question.endsWith(')')) {
            // startswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.startwith.push({ text: keyword })
          } else if (question.startsWith('endswith(') && question.endsWith(')')) {
            // endswith(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.endwith.push({ text: keyword })
          } else if (question.startsWith('startsendswith(') && question.endsWith(')')) {
            // startsendswith(...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.startandendwith.push({ text: keyword })
          } else if (question.startsWith('includes(') && question.endsWith(')')) {
            // includes(...&&...&&...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.keyword.push({ text: keyword })
          } else if (question.startsWith('exacts(') && question.endsWith(')')) {
            // exacts(...)
            pointer = question.search(/\(/g)
            keyword = question.substring(pointer + 1, question.length - 1)
            result.exactly.push({ text: keyword })
          } else {
            result.normal.push({ text: question })
          }
        })
      }
      return result
    },
    IsJsonString(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },
    ticketinit() {
      try {
        try {
          if (this.intent.intentgroup) {
            if (this.IsJsonString(this.intent.intentgroup)) {
              var ticket = JSON.parse(this.intent.intentgroup)
            } else {
              var ticket = this.intent.intentgroup
            }
            this.ticket = Object.assign(this.ticket, {
              group: ticket.assigngroupid
                ? this.agentGroup.find(el => el.id == ticket.assigngroupid)
                : '',
              subgroup: ticket.assignsubgroupid
                ? this.agentSubGroup.find(el => el.id == ticket.assignsubgroupid)
                : '',
              priority: ticket.priority
                ? this.priorityOptions.find(el => el.value == ticket.priority)
                : '',
              tags: ticket.tags
                ? ticket.tags.split(',').map(el => {
                    return { text: el }
                  })
                : []
            })
            if (ticket.duedate) {
              this.ticket.duedate = {
                start: moment(this.ticket.duedate).format('YYYY-MM-DD'),
                starttime: moment(this.ticket.duedate).format('HH:mm'),
                end: ''
              }
            }
            if (ticket.day) {
              this.ticket.day = ticket.day
            }
            if (ticket.hour) {
              this.ticket.hour = ticket.hour
            }
            if (ticket.minute) {
              this.ticket.minute = ticket.minute
            }
          }
        } catch (error) {
          console.log(error)
        }
      } catch (error) {
        console.log(error)
      }
    },
    tagsedit(index, item) {
      if (!this.tagediting) {
        this.tagediting = item
        this.index = index
      } else {
        this.tagediting = null
        this.index = -1
      }
    },
    tagsfilter(item, queryText, itemText) {
      if (item.header) return false

      const hasValue = val => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      )
    },
    onSelectedDueDate: function(value) {
      var vm = this

      if (this.ticket.duedate.end && moment(this.ticket.duedate.end).isBefore(value)) {
        this.ticket.duedate.end = value
      }
      vm.ticket.duedate.start = value
      vm.showDueDate = false
    },
    async onChangeGroup(val) {
      this.ticket.subgroup = null
      this.ticket.assignedTo = null
    },
    saveFilterPost(payload) {
      this.$set(this.intent, 'postidlist', payload.includes)
      this.$set(this.intent, 'exceptpostidlist', payload.excludes)
      var includes = []
      var excludes = []
      if (payload.includes) {
        try {
          includes = JSON.parse(payload.includes)
        } catch (error) {
          includes = payload.includes.split(',')
        }
      }
      if (payload.excludes) {
        try {
          excludes = JSON.parse(payload.excludes)
        } catch (error) {
          excludes = payload.excludes.split(',')
        }
      }
      this.postidlist = { includes, excludes }
    },
    changeOnlytime(e) {
      this.$forceUpdate()
    },
    toggleLineNotifyStatus: function() {
      this.intent.linenoti_status = !this.intent.linenoti_status
    },
    onShowAdvance: function() {
      this.showAdvanced = !this.showAdvanced
    },
    addGeneric: function() {
      this.generics.push({
        image_url: null,
        title: '',
        subtitle: '',
        buttons: [],

        enable: true
      })
    },
    saveIntent: function() {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        intentname: vm.intent.intentname,
        q_type: vm.intent.q_type,
        q_val: vm.intent.q_val,
        a_type: 'json',
        a_val: vm.intent.a_val,
        ispriority: vm.intent.ispriority,
        quick_reply: vm.intent.quick_reply,
        postidlist: vm.intent.postidlist,
        exceptpostidlist: vm.intent.exceptpostidlist ? vm.intent.exceptpostidlist : '',
        isShow: true,
        intentstatus: vm.intent.intentstatus ? vm.intent.intentstatus : false,
        onlytime: vm.intent.onlytime ? vm.intent.onlytime : false,
        intentgroup: vm.intent.intentgroup ? vm.intent.intentgroup : null
      }
      if (vm.selectedBot.theme == 'ticket') {
        data.intentgroup = vm.intentgroup
      }

      if (this.showMultipleChannel) {
        data.fb_val = JSON.stringify(vm.fb_messages).replace(/ /gim, ' ')
        data.line_val = JSON.stringify(vm.line_messages).replace(/ /gim, ' ')
      }

      if (vm.$store.getters.getPackage == 'premium') {
        data.context_in = vm.intent.context_in != null ? vm.intent.context_in : ''
        data.context_out = vm.intent.context_out != null ? vm.intent.context_out : ''
        data.userstatus = vm.intent.userstatus
        data.usertags = vm.intent.usertags
        data.linenoti_status = vm.intent.linenoti_status
        data.linenoti_text = vm.intent.linenoti_text
        data.starttime = vm.startTimeFormat ? vm.startTimeFormat + moment().format('Z') : null
        data.endtime = vm.endTimeFormat ? vm.endTimeFormat + moment().format('Z') : null
        if (vm.isCommentToInbox) {
          data.remaining_reply = vm.remaining_reply == false ? null : vm.remaining_reply
          data.notreplysameperson = vm.notreplysameperson
        }
      } else {
        data.context_in = vm.cached_intent.context_in != null ? vm.cached_intent.context_in : ''
        data.context_out = vm.cached_intent.context_out != null ? vm.cached_intent.context_out : ''
        data.userstatus = vm.cached_intent.userstatus
        data.usertags = vm.cached_intent.usertags
        data.linenoti_status = vm.cached_intent.linenoti_status
        data.linenoti_text = vm.cached_intent.linenoti_text
        data.starttime = vm.cached_intent.starttime ? vm.cached_intent.starttime : null
        data.endtime = vm.cached_intent.endtime ? vm.cached_intent.endtime : null
        if (vm.isCommentToInbox) {
          data.remaining_reply = null
          data.notreplysameperson = false
        }
      }

      if (vm.isWelcome) {
        var welcome_answer = [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
        data.a_val = JSON.stringify(welcome_answer)
      } else {
        if (vm.isCommentToInbox && !vm.isLiveStream) {
          var message = []
          if (vm.messages) {
            message = vm.checkEmptyReplyMessage(vm.messages)
          }

          if (message.length === 0) {
            message.push([
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: ''
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ])
          }
          data.a_val = JSON.stringify(message).replace(/ /gim, ' ')
          data.context_in = 'comment'
          data.a_type = 'json'
        } else if (vm.isLiveStream) {
          var message = []
          if (vm.messages) {
            message = vm.checkEmptyReplyMessage(vm.messages)
          }

          if (message.length === 0) {
            message.push([
              {
                type: 'responsepost',
                replyinbox: true,
                replycomment: false,
                hidecomment: false,
                responseinbox: [
                  {
                    type: 'text',
                    text: ''
                  }
                ],
                responsecomment: [
                  {
                    type: 'text',
                    text: ''
                  }
                ]
              }
            ])
          }
          data.a_val = JSON.stringify(message).replace(/ /gim, ' ')
          data.context_in = 'facebooklive'
          data.a_type = 'json'
        } else if (data.a_type === 'json') {
          var messages = vm.checkEmptyMessage(vm.messages)

          data.a_val = JSON.stringify(messages)
        }
      }
      vm.$validator
        .validateAll()
        .then(result => {
          if (!result) {
            vm.goToErrorInput()
            // do stuff if not valid.
            // console.log(this.$validator.errors.items)
            return false
          }

          if (!vm.intent.id) {
            vm.$store.dispatch('loading')
            console.log('data',data)
            api.addIntent(data, function(error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }
              data.id = response.id
              vm.$emit('input', data)
              vm.$emit('saveIntent', data)
              vm.$emit('close', null)
              vm.$store.dispatch('loading')
              vm.intent = {
                intentname: '',
                q_type: 'text',
                a_type: 'json',
                q_val: '',
                a_val: [[]],
                context_in: '',
                context_out: '',
                postidlist: '',
                exceptpostidlist: ''
              }
              vm.cached_intent = Object.assign({}, vm.intent)
            })
          } else {
            data['id'] = vm.intent.id
            vm.$store.dispatch('loading')
            console.log('data',data)
            api.editIntent(data, function(error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }
              vm.$emit('input', data)
              // console.log(data)
              vm.$emit('saveIntent', data)
              vm.cached_intent = Object.assign({}, vm.intent)

              vm.$store.dispatch('loading')
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    cancelEdit: function() {
      var vm = this
      vm.intent = Object.assign({}, vm.cached_intent)
      vm.$emit('close', null)
    },
    checkTag(obj) {
      this.errorQuestionTag = []
      if (obj.tag.text == '') {
      } else if (obj.tag.isDuplicate) {
        // this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorQuestionTag.push('duplicate')
        obj.error()
      } else obj.addTag()

      // if (obj.tag.text.includes(',')) alert('Letter "," is forbidden');
    },
    checkQuickReply(obj) {
      // if (obj.tag.text.includes(',')) alert('Letter "," is forbidden');
      // else

      this.errorTag = []
      if (obj.tag.text == '') {
      } else if (obj.tag.text.length >= 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.type == 'add' && this.replies.length >= 10) {
        this.errorTag.push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        // this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    checkUserTags(obj) {
      this.errorUserTags = []
      if (obj.tag.text == '') {
      }
      // else if (obj.tag.text.length > 20) {
      //   this.errorUserTags.push('overmaxlength')
      //   obj.error()
      // }
      else if (obj.tag.isDuplicate) {
        this.errorUserTags.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onDeleteGeneric(index) {
      this.generics.splice(index, 1)
    },
    onMove: function(index, direction) {
      var vm = this
      if (direction === 'left') {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0])
      } else if (direction === 'right') {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0])
      }
    },
    onChangeReplyComment: function() {
      if (this.isReplyComment) {
        this.intent.context_in = 'comment'
        this.replyComment = ''
      } else {
        this.intent.context_in = ''
        this.replyComment = ''
      }
    },
    onChangeIntentStatus: function() {
      let intentstatus = this.intent.intentstatus ? this.intent.intentstatus : false
      this.$set(this.intent, 'intentstatus', !intentstatus)
    },
    onChangeIntentOnlyTime: function() {
      let onlytime = this.intent.onlytime ? this.intent.onlytime : false

      this.$set(this.intent, 'onlytime', !onlytime)
    },
    addIntentPrefill: function(prefill) {
      var vm = this
      let cursorPosition = this.$refs.replyComment.$el.selectionStart
      vm.replyComment = [
        vm.replyComment.slice(0, cursorPosition),
        '{' + prefill + '}',
        vm.replyComment.slice(cursorPosition)
      ].join('')
    },
    addEmoji: function(emoji) {
      var vm = this
      let cursorPosition = this.$refs.answer[this.currentIndex].$el.selectionStart
      vm.replyComment = [
        vm.replyComment.slice(0, cursorPosition),
        emoji.native,
        vm.replyComment.slice(cursorPosition)
      ].join('')
      vm.showEmoji = false
    },
    changeIntentType: function(type) {
      var vm = this
      if (type == 'text' && (vm.intent.a_type == '' || vm.intent.a_type == null)) {
        this.text = this.intent.a_val
      }

      if (vm.intent.a_type == 'text') {
        this.text = this.intent.a_val
      }

      if (type == 'text') {
        this.intent.a_val = this.text
      }
      vm.intent.a_type = type
    },
    addReplies: function(newTags) {
      this.replies = newTags
      // console.log(newTags,this.replies)
    },
    addUserTags: function(newTags) {
      this.usertags = newTags
    },
    onSelected(option) {
      this.selected = option.item
    },
    onInputChange(text) {
      if (text === '' || text === undefined) {
        return
      }

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.options[0].data
        .filter(item => {
          return item.toLowerCase().indexOf(text.toLowerCase()) > -1
        })
        .slice(0, this.limit)

      this.filteredOptions = [
        {
          data: filteredData
        }
      ]
    }
  },
  watch: {
    showPreview: function(newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    'intent.context_in': function(newVal, oldVal) {
      if (newVal == 'comment') {
        this.isReplyComment = true
      } else {
        this.isReplyComment = false
      }
    },
    tickettags(val, prev) {
      if (val.length === prev.length) return

      this.ticket.tags = val.map(v => {
        if (typeof v === 'string') {
          v = {
            text: v
          }
          this.$nextTick(() => {
            this.tagitems.push(v)
            this.$forceUpdate()
          })
        }

        return v
      })
    },
    value: function(newVal, oldVal) {
      var vm = this
      vm.intent = Object.assign({}, vm.value)
      vm.cached_intent = Object.assign({}, vm.value)
      if (vm.intent.starttime) {
        var startTime = moment(vm.intent.starttime)
        vm.startDate = startTime.format('YYYY-MM-DD')
        vm.startTime = startTime.format('HH:mm')
      }
      if (vm.intent.endtime) {
        var endTime = moment(vm.intent.endtime)
        vm.endDate = endTime.format('YYYY-MM-DD')
        vm.endTime = endTime.format('HH:mm')
      }

      if (vm.value.a_type == 'text') {
      }

      if (vm.value.a_type == 'template') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          vm.generics = JSON.parse(vm.value.a_val)
        } else {
          vm.generics = []
        }
      }

      if (vm.value.a_type == 'json') {
        if (vm.isJsonParseable(vm.value.a_val)) {
          vm.messages = JSON.parse(vm.value.a_val)
        } else {
          vm.messages = []
        }
      }

      if (vm.value.context_in == 'comment') {
        vm.replyComment = vm.value.a_val
      }
    },
    excludedIntentName: function() {
      var vm = this
      vm.intents = vm.excludedIntentName.split(',')
      vm.intents.push('comment')
      vm.intents.push('{default}')
      vm.intents.push('{welcome}')
      vm.intents.push('{default_comment_to_inbox}')

      if (vm.type == 'edit' && vm.excludedIntentName && vm.excludedIntentName != '' && vm.intent) {
        var result = []
        var names = vm.intents
        $.each(names, function(index, name) {
          if (name == vm.intent.intentname) {
            names.splice(index, 1)
            return false
          }
        })

        vm.excludedName = names.join(',').replace('|', '//#or//')
      } else {
        vm.excludedName = vm.intents.join(',').replace('|', '//#or//')
      }
    }
  }
}
</script>
<style lang="scss" scope>
.success--text {
  color: #ff706b !important;
  caret-color: #ff706b !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/intent-manage.vue